export default {
  paymentApplyList: {
    search: {
      requestDepartmentCode: '部门',
      requestDepartmentCodePlaceholder: '请选择部门',
      paymentApplyNumber: '申请单号',
      paymentApplyNumberPlaceholder: '请输入申请单号',
      payeeNos: '收款单位',
      payeeNosPlaceholder: '请选择收款单位',
      paymentMethod: '付款方式',
      paymentMethodPlaceholder: '请选择付款方式',
      paymentType: '付款类别',
      paymentTypePlaceholder: '请选择付款类别',
      requestStatus: '单据状态',
      requestStatusPlaceholder: '请选择单据状态',
      expenseType: '款项内容',
      expenseTypePlaceholder: '请选择款项内容',
      requestPersonName: '创建人',
      requestPersonNamePlaceholder: '请输入创建人',
      startRequestDate: '申请日期从',
      startRequestDatePlaceholder: '请选择申请开始日期',
      endRequestDate: '申请日期至',
      endRequestDatePlaceholder: '请选择申请结束日期',
      startGmtCreate: '创建日期从',
      startGmtCreatePlaceholder: '请选择创建开始日期',
      endGmtCreate: '创建日期至',
      endGmtCreateDatePlaceholder: '请选择创建结束日期',
      startRequestAmount: '申请金额',
      purchaseOrderNo: '采购合同号',
      purchaseOrderNoPlaceholder: '请输入采购合同号',
      salesOrderNo: '销售合同号',
      salesOrderNoPlaceholder: '请输入销售合同号',
      unpaidAmount: '未付款金额',
      unpaidAmountPlaceholder: '请输入未付款金额',
      isPrepay: '预付',
    },
    table: {
      requestCompanyCode: '公司代码',
      requestCompanyName: '公司名称',
      requestDepartmentCode: '部门代码',
      requestDepartmentName: '部门名称',
      paymentApplyNumber: '申请单号',
      payeeNo: '收款单位',
      bankName: '开户银行',
      bankAccount: '银行账号',
      requestAmount: '申请金额',
      paidAmount: '已付金额',
      unpaidAmount: '未付金额',
      currencyName: '币种',
      paymentType: '付款类别',
      paymentMethod: '付款方式',
      requestPersonName: '申请人',
      requestDate: '申请日期',
      requestStatus: '单据状态',
      paymentStatus: '付款状态',
    },
  },
};
